/**
 * This utility function returns filename + extension by taking the last split segment from the file uri
 * @param file File object
 */
export function getSafeFileName(fileName: string, fileUri: string) {
  const uriExtension = `.${fileUri.split(".").pop()}`.toLowerCase();
  if (fileName.toLowerCase().endsWith(uriExtension)) {
    return fileName;
  }

  return `${fileName}${uriExtension}`;
}
